import { Music, Globe, Database } from "lucide-react";
import { FooterLink } from "./FooterLinks";
 import { getProgramName } from "@/config/programBranding";

export const discoverLinks: FooterLink[] = [
  { label: "Buscar Gimnasios", to: "/directory" },
  { label: `${getProgramName("trainer")} - Entrenadores`, to: "/trainers" },
  { label: "Eventos Deportivos", to: "/events" },
  { label: "Videos de Entrenamiento", to: "/videos" },
  { label: "Artículos y Blog", to: "/articles" },
  { label: "Cerca de Mí", to: "/cerca-de-mi" },
];


export const professionalsLinks: FooterLink[] = [
  { label: `${getProgramName("trainer")} - 90 Días Gratis`, to: "/become-trainer", emoji: "🏋️" },
  { label: `${getProgramName("physiotherapist")} - Hazte Fisio`, to: "/become-physiotherapist", emoji: "💆" },
  { label: `${getProgramName("nutritionist")} - Hazte Nutri`, to: "/become-nutritionist", emoji: "🥗" },
  { label: "Tiendas y Proveedores", to: "/tiendas-proveedores", emoji: "🏪" },
  { label: "Registra tu Negocio", to: "/submit-listing" },
];

export const landingPagesLinks: FooterLink[] = [
  { label: `${getProgramName("trainer")} - Entrenadores`, to: "/become-trainer", emoji: "🏋️" },
  { label: `${getProgramName("physiotherapist")} - Fisios`, to: "/become-physiotherapist", emoji: "💆" },
  { label: `${getProgramName("nutritionist")} - Nutris`, to: "/become-nutritionist", emoji: "🥗" },
  { label: `${getProgramName("yoga")} - Yoga`, to: "/landing-yoga", emoji: "🧘" },
  { label: `${getProgramName("crossfit")} - CrossFit`, to: "/landing-crossfit", emoji: "💪" },
  { label: `${getProgramName("gym")} - Gimnasios`, to: "/landing-fitness", emoji: "🏢" },
  { label: `${getProgramName("pilates")} - Pilates`, to: "/landing-pilates", emoji: "🤸" },
  { label: `${getProgramName("dance")} - Baile`, to: "/landing-dance", emoji: "💃" },
  { label: `${getProgramName("martial_arts")} - Artes Marciales`, to: "/landing-martial-arts", emoji: "🥋" },
];

export const internationalLinks: FooterLink[] = [
  { label: "🇬🇧 Ekselencia English", to: "https://en.ekselencia.com", icon: Globe, external: true },
  { label: "🇳🇱 Ekselencia Nederland", to: "https://nl.ekselencia.com", icon: Globe, external: true },
];

export const legalLinks: FooterLink[] = [
  { label: "Preguntas Frecuentes", to: "/faq" },
  { label: "Términos y Condiciones", to: "/terminos" },
  { label: "Política de Privacidad", to: "/privacidad" },
  { label: "Política de Devoluciones", to: "/devoluciones" },
  { label: "Métodos de Pago", to: "/metodos-pago" },
  { label: "Mapa del Sitio", to: "/sitemap" },
  { label: "Dataset LLM", to: "/llm-dataset.txt", icon: Database },
];
